import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';
import commonBaseService from '../../../../services/commonBaseService';


const MODULE_PREFIX = '[ OPTION_CHAIN ]';
const COMMON_OPTION_CHAIN_ID_STRUCTURE = {
    expiryDateOptions: [],
    selectedExpiryDate: '',
    selectedExpiryData: {},
}

const COMMON_EXP_DATE_OPTION_CHAIN_STRUCTURE = {
    data: [],
    maxCallOi: '',
    maxPutOi: '',
    isEmptyList: false,
}
const Actions = {
    fetchOptionChainExpDates: `${MODULE_PREFIX} fetchOptionChainExpDates`,
    setOptionChainExpDates: `${MODULE_PREFIX} setOptionChainExpDates`,
    setSelectedOptionChainExpiryDate : `${MODULE_PREFIX} setSelectedOptionChainExpiryDate`,
    setSelectedOptionChainExpiryDateData: `${MODULE_PREFIX} setSelectedOptionChainExpiryDateData`,
    setLotSelection: `${MODULE_PREFIX} setLotSelection`,
    setLtpOiSelection: `${MODULE_PREFIX} setLtpOiSelection`,
    fetchOptionChain: `${MODULE_PREFIX} fetchOptionChain`,
    setOptionChain: `${MODULE_PREFIX} setOptionChain`,
    setIsExpSheetOpen: `${MODULE_PREFIX} setIsExpSheetOpen`,
    setMaxCallOi: `${MODULE_PREFIX} setMaxCallOi`,
    setMaxPutOi: `${MODULE_PREFIX} setMaxPutOi`,
    fetchAboveOptionChainItems : `${MODULE_PREFIX} fetchAboveOptionChainItems`,
    fetchBelowOptionChainItems: `${MODULE_PREFIX} fetchBelowOptionChainItems`,
    setAbovePageUrl : `${MODULE_PREFIX} setAbovePageUrl`,
    setBelowPageUrl: `${MODULE_PREFIX} setBelowPageUrl`,
    setAbovePageOptionChainData: `${MODULE_PREFIX}  setAbovePageOptionChainData`,
    setBelowPageOptionChainData: `${MODULE_PREFIX} setBelowPageOptionChainData`,
};

export const fetchOptionChainExpDates = createAction(Actions.fetchOptionChainExpDates);
export const setOptionChainExpDates = createAction(Actions.setOptionChainExpDates);
export const setSelectedOptionChainExpiryDate = createAction(Actions.setSelectedOptionChainExpiryDate);
export const setSelectedOptionExpiryDateData = createAction(Actions.setSelectedOptionChainExpiryDateData);
export const fetchOptionChain = createAction(Actions.fetchOptionChain);
export const setOptionChain = createAction(Actions.setOptionChain);
export const setMaxCallOi = createAction(Actions.setMaxCallOi);
export const setMaxPutOi = createAction(Actions.setMaxPutOi);
export const fetchAboveOptionChainItems = createAction(Actions.fetchAboveOptionChainItems);
export const fetchBelowOptionChainItems = createAction(Actions.fetchBelowOptionChainItems);
export const setAbovePageUrl = createAction(Actions.setAbovePageUrl);
export const setBelowPageUrl = createAction(Actions.setBelowPageUrl);
export const setAbovePageOptionChainData = createAction(Actions.setAbovePageOptionChainData);
export const setBelowPageOptionChainData = createAction(Actions.setBelowPageOptionChainData);


export const getSelectedOptionchainExpiryDates = (state, selectedOptionchainId) => {
    const selectedOptionchainIdExpDates = get(state, `optionChain.${selectedOptionchainId}.expiryDateOptions`, []);
    return selectedOptionchainIdExpDates;
}

export const getSelectedOptionchainExpiryDate =  (state, selectedOptionchainId) => {
    const selectedOptionchainIdExpDate= get(state, `optionChain.${selectedOptionchainId}.selectedExpiryDate`, []);
    return selectedOptionchainIdExpDate;
}

export const getSelectedOptionchainExpiryDateData = (state, selectedOptionchainId) => {
    const selectedOptionchainIdExpDateData= get(state, `optionChain.${selectedOptionchainId}.selectedExpiryData`, []);
    return selectedOptionchainIdExpDateData;
}

export const getOptionChainData = (state, selectedOptionchainId) => {
    const selectedOptionchainIdExpDate= get(state, `optionChain.${selectedOptionchainId}.selectedExpiryDate`, []);
    const optionChainV2Data = get(state, `optionChain.${selectedOptionchainId}.${selectedOptionchainIdExpDate}`, {});
    return optionChainV2Data;
}

export const getMaxCallOi = (state, selectedOptionchainId) => {
    const selectedOptionchainIdExpDate= get(state, `optionChain.${selectedOptionchainId}.selectedExpiryDate`, []);
    const maxCallOi = get(state, `optionChain.${selectedOptionchainId}.${selectedOptionchainIdExpDate}.maxCallOi`, {});
    return maxCallOi;
}

export const getMaxPutOi = (state, selectedOptionchainId) => {
    const selectedOptionchainIdExpDate= get(state, `optionChain.${selectedOptionchainId}.selectedExpiryDate`, []);
    const maxPutOi = get(state, `optionChain.${selectedOptionchainId}.${selectedOptionchainIdExpDate}.maxPutOi`, {});
    return maxPutOi;
}

const initialState = {};

export default createReducer(initialState, (builder) => {
    builder.addCase(setOptionChainExpDates, (state, {payload}) => {
        const {expiryDateOptions, selectedOptionChainId} = payload
        if(commonBaseService.isEmptyOrUndefined(state[selectedOptionChainId])) {
            state[selectedOptionChainId] = {...COMMON_OPTION_CHAIN_ID_STRUCTURE};
            state[selectedOptionChainId].expiryDateOptions  = expiryDateOptions;
        }
    });
    builder.addCase(setSelectedOptionChainExpiryDate, (state, {payload}) => {
        const {selectedOptionChainId, selectedExpiryDate} = payload;
         if(commonBaseService.isEmptyOrUndefined(state[selectedOptionChainId])) {
            state[selectedOptionChainId] = {...COMMON_OPTION_CHAIN_ID_STRUCTURE};
        }
        state[selectedOptionChainId].selectedExpiryDate = selectedExpiryDate;
    });
    builder.addCase(setSelectedOptionExpiryDateData, (state, {payload}) => {
        const {selectedOptionChainId, selectedExpiryData} = payload;
        if(commonBaseService.isEmptyOrUndefined(state[selectedOptionChainId])) {
           state[selectedOptionChainId] = {...COMMON_OPTION_CHAIN_ID_STRUCTURE};
       }
       state[selectedOptionChainId].selectedExpiryData = selectedExpiryData;
    });
    builder.addCase(setOptionChain, (state, {payload}) => {
        const {selectedOptionChainId, optionChainData} = payload;
        const selectedExpDate = state[selectedOptionChainId].selectedExpiryDate;
        if(commonBaseService.isEmptyOrUndefined(state[selectedOptionChainId][selectedExpDate])) {
          state[selectedOptionChainId][selectedExpDate] = {...COMMON_EXP_DATE_OPTION_CHAIN_STRUCTURE};
          state[selectedOptionChainId][selectedExpDate].data = optionChainData;
          state[selectedOptionChainId][selectedExpDate].isEmptyList = commonBaseService.isEmptyOrUndefined(get(optionChainData, 'data', []));
        }  else {
            state[selectedOptionChainId][selectedExpDate].data = optionChainData;
            state[selectedOptionChainId][selectedExpDate].isEmptyList = commonBaseService.isEmptyOrUndefined(get(optionChainData, 'data', []))
        }
    });
    builder.addCase(setMaxCallOi, (state, {payload}) => {
        const {selectedOptionChainId, maxCallOi} = payload;
        const selectedExpDate = state[selectedOptionChainId].selectedExpiryDate;
        if(commonBaseService.isEmptyOrUndefined(state[selectedOptionChainId][selectedExpDate])) {
            state[selectedOptionChainId][selectedExpDate] = {...COMMON_EXP_DATE_OPTION_CHAIN_STRUCTURE};
            state[selectedOptionChainId][selectedExpDate].maxCallOi = maxCallOi;
          }  else {
              state[selectedOptionChainId][selectedExpDate].maxCallOi = maxCallOi;
          }
    });
    builder.addCase(setMaxPutOi, (state, {payload}) => {
        const {selectedOptionChainId, maxPutOi} = payload;
        const selectedExpDate = state[selectedOptionChainId].selectedExpiryDate;
        if(commonBaseService.isEmptyOrUndefined(state[selectedOptionChainId][selectedExpDate])) {
            state[selectedOptionChainId][selectedExpDate] = {...COMMON_EXP_DATE_OPTION_CHAIN_STRUCTURE};
            state[selectedOptionChainId][selectedExpDate].maxPutOi = maxPutOi;
          }  else {
              state[selectedOptionChainId][selectedExpDate].maxPutOi = maxPutOi;
          }
    })
    builder.addCase(setAbovePageUrl, (state, {payload}) => {
        const {selectedOptionChainId, above_page_url} = payload;
        const selectedExpDate = state[selectedOptionChainId].selectedExpiryDate;
        state[selectedOptionChainId][selectedExpDate].data.above_page_url = above_page_url;
    });
    builder.addCase(setBelowPageUrl, (state, {payload}) => {
        const {selectedOptionChainId, below_page_url} = payload;
        const selectedExpDate = state[selectedOptionChainId].selectedExpiryDate;
        state[selectedOptionChainId][selectedExpDate].data.below_page_url = below_page_url;
    });
    builder.addCase(setAbovePageOptionChainData, (state, {payload}) => {
        const {selectedOptionChainId, optionChainData} = payload;
        const selectedExpDate = state[selectedOptionChainId].selectedExpiryDate;
        const existingData =  state[selectedOptionChainId][selectedExpDate].data.data;
        state[selectedOptionChainId][selectedExpDate].data.data = [...optionChainData, ...existingData];
    });
    builder.addCase(setBelowPageOptionChainData, (state, {payload}) => {
        const {selectedOptionChainId, optionChainData} = payload;
        const selectedExpDate = state[selectedOptionChainId].selectedExpiryDate;
        const existingData =  state[selectedOptionChainId][selectedExpDate].data.data;
        state[selectedOptionChainId][selectedExpDate].data.data = [...existingData, ...optionChainData];
    });
});
